<template>
  <v-container fluid grid-list-md py1 class="campana mb-8">
    <v-layout row wrap>
      <v-flex md12>
        <data-table ref="campanaTable" @editRow="load" @auditRow="audit" />
      </v-flex>
      <v-flex md12>
        <v-card>
          <v-card-title primary-title class="py-2">
            <v-toolbar-title>{{ $t("view.operativos.campana.title") }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="view.elem.showForm = !view.elem.showForm">
              <v-icon>{{ view.elem.showForm ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
            </v-btn>
          </v-card-title>
          <v-expand-transition>
            <v-flex v-show="view.elem.showForm" class="py-0">
              <v-card-text>
                <form onSubmit="return false;" @submit="submit" @keyup.ctrl.83="executeValidators">
                  <v-layout row>
                    <!-- Descripcion -->
                    <v-flex md3>
                      <v-text-field
                        v-model.trim="$v.campana.descripcion.$model"
                        :label="$t('view.operativos.campana.form.descripcion.label')"
                        :error-messages="getFirstErrorDescription($v.campana.descripcion)"
                        maxlength="50"
                        :disabled="view.action.submit.busy"
                        onkeypress="return /^\w+$/.test(event.key);" />
                    </v-flex>

                    <!-- Descripcion APP -->
                    <v-flex md3>
                      <v-text-field
                        v-model.trim="$v.campana.descripcionapp.$model"
                        :label="$t('view.operativos.campana.form.descripcionapp.label')"
                        :error-messages="getFirstErrorDescription($v.campana.descripcionapp)"
                        maxlength="15"
                        :disabled="view.action.submit.busy"
                        onkeypress="return /^\w+$/.test(event.key);" />
                    </v-flex>

                    <!-- Fecha Fin en App (Informativos, Solo lectura) -->
                    <v-flex v-if="campana.fincampanaapp" md3>
                      <datePicker
                        ref="datePickerDateFinCampanaApp"
                        :key="refreshkey"
                        :name="'fincampanaapp'"
                        :label="$t('view.operativos.campana.form.fincampanaapp.label')"
                        :value.sync="campana.fincampanaapp"
                        :disabled="true"
                        :errormessages="getFirstErrorDescription($v.campana.fincampanaapp)" />
                    </v-flex>
                  </v-layout>
                  <!-- =================================================================================== -->
                  <v-layout row>
                    <!-- SE -->
                    <v-flex md3>
                      <v-autocomplete
                        v-model.trim="$v.campana.se.$model"
                        :label="$t('view.operativos.campana.form.se.label')"
                        :error-messages="getFirstErrorDescription($v.campana.se)"
                        :items="view.elem.select.se.filteredList"
                        :loading="view.elem.select.se.loading"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        clearable
                        :no-data-text="$t('view.commons.nodata')"
                        onkeypress="return /^[a-z0-9]+$/i.test(event.key);"
                        @input.native="loadListSe"
                        @input="search = ''" />
                    </v-flex>

                    <!-- Vendor -->
                    <v-flex md3>
                      <v-autocomplete
                        v-model.trim="$v.campana.vendor.$model"
                        :label="$t('view.operativos.campana.form.vendor.label')"
                        :error-messages="getFirstErrorDescription($v.campana.vendor)"
                        :items="view.elem.select.vendor.filteredList"
                        :disabled="view.action.submit.busy"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        clearable
                        :no-data-text="$t('view.commons.nodata')"
                        @input="search = ''" />
                    </v-flex>

                    <!-- Canales -->
                    <v-flex md6>
                      <v-autocomplete
                        v-model.trim="$v.campana.canales.$model"
                        :label="$t('view.operativos.campana.form.canales.label')"
                        :error-messages="getFirstErrorDescription($v.campana.canales)"
                        :items="view.elem.select.canales.filteredList"
                        :disabled="view.action.submit.busy || view.elem.select.canales.disabled"
                        item-value="code"
                        item-text="name"
                        hide-selected
                        deletable-chips
                        clearable
                        multiple
                        small-chips
                        :no-data-text="$t('view.commons.nodata')"
                        @input="search = ''" />
                    </v-flex>
                  </v-layout>
                  <!-- =================================================================================== -->
                  <v-layout row>
                    <!-- Fecha Limite Campanas Process -->
                    <v-flex md6>
                      <label for="dateresini" class="v-label mt-3">{{ $t("view.operativos.campana.form.dateres.label") }}</label>
                      <v-layout row>
                        <v-flex md6>
                          <datePicker
                            ref="datePickerDateResIni"
                            :key="refreshkey"
                            :name="'dateresini'"
                            :label="$t('view.commons.dateIni')"
                            :value.sync="campana.dateresini"
                            :disabled="view.action.submit.busy"
                            :errormessages="getFirstErrorDescription($v.campana.dateresini)"
                            @changeDate="changeDate" />
                        </v-flex>
                        <v-flex md6>
                          <datePicker
                            ref="datePickerDateResend"
                            :key="refreshkey"
                            :name="'dateresend'"
                            :label="$t('view.commons.dateEnd')"
                            :value.sync="campana.dateresend"
                            :disabled="view.action.submit.busy"
                            :errormessages="getFirstErrorDescription($v.campana.dateresend)"
                            :min="campana.dateresini"
                            :enable-today="new Date(campana.dateresini) <= new Date()"
                            @changeDate="changeDate" />
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <!-- Fecha Limite Campanas (Informativos) -->
                    <v-flex md6>
                      <label for="datelimini" class="v-label mt-3">{{ $t("view.operativos.campana.form.datelim.label") }}</label>
                      <v-layout row>
                        <v-flex md6>
                          <datePicker
                            ref="datePickerDateLimIni"
                            :key="refreshkey"
                            :name="'datelimini'"
                            :label="$t('view.commons.dateIni')"
                            :value.sync="campana.datelimini"
                            :disabled="view.action.submit.busy"
                            :errormessages="getFirstErrorDescription($v.campana.datelimini)"
                            @changeDate="changeDate" />
                        </v-flex>
                        <v-flex md6>
                          <datePicker
                            ref="datePickerDateLimend"
                            :key="refreshkey"
                            :name="'datelimend'"
                            :label="$t('view.commons.dateEnd')"
                            :value.sync="campana.datelimend"
                            :disabled="view.action.submit.busy"
                            :errormessages="getFirstErrorDescription($v.campana.datelimend)"
                            :min="campana.datelimini"
                            :enable-today="new Date(campana.datelimini) <= new Date()"
                            @changeDate="changeDate" />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <!-- =================================================================================== -->
                  <v-layout row>
                    <!-- Cuota Simple -->
                    <v-flex md3 xl1>
                      <label for="cuotasimple" class="v-label mt-3">{{ $t("view.operativos.campana.form.cuotasimple.label") }}</label>
                      <v-switch v-model="campana.cuotasimple" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Benef Pref -->
                    <v-flex md3 xl1>
                      <label for="benefpref" class="v-label mt-3">{{ $t("view.operativos.campana.form.benefpref.label") }}</label>
                      <v-switch v-model="campana.benefpref" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Contact Pref -->
                    <v-flex md3 xl1>
                      <label for="contactpref" class="v-label mt-3">{{ $t("view.operativos.campana.form.contactpref.label") }}</label>
                      <v-switch v-model="campana.contactpref" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- OOB -->
                    <v-flex md3 xl1>
                      <label for="oob" class="v-label mt-3">{{ $t("view.operativos.campana.form.oob.label") }}</label>
                      <v-switch v-model="campana.oob" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>

                    <!-- Estatus -->
                    <v-flex md3 xl1>
                      <label for="status" class="v-label mt-3">{{ $t("view.commons.status") }}</label>
                      <v-switch v-model="campana.status" input-value="true" color="primary" :disabled="view.action.submit.busy" />
                    </v-flex>
                  </v-layout>
                </form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-flex shrink>
                  <v-btn
                    v-show="campana.clave && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
                    id="btnaudit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="$t('view.commons.audit')"
                    :loading="view.action.submit.busy"
                    @click="audit()">
                    <v-icon small>storage</v-icon>
                  </v-btn>

                  <v-btn id="btnclear" fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.cancel')" :loading="view.action.submit.busy" @click="clear()">
                    <v-icon small>fa-eraser</v-icon>
                  </v-btn>

                  <v-btn
                    v-show="$userPermission.hasPermission('ROLE_MODIFICAR_OP')"
                    id="btnsubmit"
                    fab
                    small
                    color="primary"
                    class="btn_tippy"
                    elevation="0"
                    :title="view.elem.button.submit.title.current"
                    :loading="view.action.submit.busy"
                    :disabled="form.$state.isDisableButtonSubmit()"
                    @click="submit()">
                    <v-icon small>{{ view.elem.button.submit.class.current }}</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-flex>
          </v-expand-transition>
        </v-card>
      </v-flex>
    </v-layout>
    <auditoria ref="auditModal" />
  </v-container>
</template>
<script>
import campanaStates from "@/views/operativos/campana/campana-state"; /** *******************************/
import campanaAPI from "@/services/operativos/campana"; /** *******************************/
import CombosAPI from "@/services/catalogos"; /** *******************************/
import DataTable from "@/views/operativos/campana/DataTable"; /** *******************************/
import Auditoria from "@/components/auditoria/Auditoria"; /** *******************************/
import DatePicker from "@/components/forms/DatePicker"; /** *******************************/
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { required } from "vuelidate/lib/validators";
import { fixMigImp } from "@/helpers/vuelidate/validators";
import { allValidatorMethods } from "@/helpers/vuelidate";
import { handleResponse } from "@/helpers/http-response-handler";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { CANALES_SELECT } from "@/constants/operativos";
import { submit } from "@/constants/buttons";
import tippy from "tippy.js";
import debounce from "debounce";

const select = {
  se: {
    completeList: []
    , filteredList: []
    , loading: false
  }
  , vendor: {
    completeList: []
    , filteredList: []
  }
  , canales: {
    filteredList: CANALES_SELECT
    , disabled: false
  }
};

const action = { submit: { busy: false } };

export default {
  name: "CampanaModule"
  , components: {
    DataTable
    , Auditoria
    , DatePicker
  }
  , data() {
    return {
      campana: undefined
      , form: new Object()
      , refreshkey: 0
      , view: {
        title: this.$t("view.operativos.campana.title")
        , action
        , elem: {
          button: { submit }
          , select
          , showForm: true
        }
      }
    };
  }
  , head: {
    title: function () {
      return {
        inner: this.view.title
        , separator: "|"
        , complement: this.$t("view.commons.system")
      };
    }
  }
  , created() {
    this.form = new campanaStates(this);
    this.form.$setState("initial");
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    ...allValidatorMethods
    , async submit() {
      try {
        const respuesta = await this.form.$state.submit(this.campana);
        if (handleResponse(respuesta, this.$t("view.operativos.campana.errors"))) {
          this.form.$setState("editing", respuesta.data.results.campana);
        }
      } catch (error) {
        handleResponse(error, this.$t("view.operativos.campana.errors"));
      }
    }
    , async load(clave) {
      try {
        const response = await campanaAPI.get(clave);
        const { data: { results: { campana } } } = response;
        this.form.$setState("editing", campana);
      } catch (error) {
        console.log(error);
      }
    }
    , async clear() {
      await this.form.$state.askForClear();
      setTimeout(() => document.body.click(), 300);
    }
    , async audit(clave = this.campana.clave, dataDescripcion = this.campana.descripcion) {
      this.$refs.auditModal.loadAudit(clave, "TCampana", dataDescripcion, this.view.title);
    }
    , executeValidators() {
      if (!this.isAllValid(this.$v)) {
        EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", this.$t("errors.validof"));
        scrollToForm(this);
      }
    }
    , changeDate(field, value) {
      this.campana[field] = value;
      this.changeDateResIni();
      this.changeDateLimIni();
    }
    , changeDateResIni() {
      if (new Date(this.campana.dateresend) < new Date(this.campana.dateresini)) {
        this.campana.dateresend = this.campana.dateresini;
        this.refreshkey += 1;
      }
    }
    , changeDateLimIni() {
      if (new Date(this.campana.datelimend) < new Date(this.campana.datelimini)) {
        this.campana.datelimend = this.campana.datelimini;
        this.refreshkey += 1;
      }
    }
    , async loadListSeM(value) {
      select.se.loading = true;
      const { data: { results: { combo: seList } } } = await CombosAPI.getSeverSide({ option: "ssse", keyword: value + "_" });
      select.se.filteredList = seList || [];
      select.se.completeList = seList || [];
      select.se.loading = false;
    }
    , loadListSe: debounce(async (event) => {
      try {
        const { srcElement: { value } } = event;
        if (value.length > 2) {
          select.se.loading = true;
          const { data: { results: { combo: seList } } } = await CombosAPI.getSeverSide({ option: "ssse", keyword: value });
          select.se.filteredList = seList ? seList.filter((value1) => value1.status) : [];
          select.se.completeList = seList || [];
          select.se.loading = false;
        }
      } catch (error) {
        console.error("equis" + error);
      }
    }, 50).bind(this)
  }
  , validations: {
    campana: {
      descripcion: { required, fixMigImp: fixMigImp() }
      , descripcionapp: { required, fixMigImp: fixMigImp() }
      , se: {}
      , vendor: {}
      , canales: { required }
      , dateresini: {}
      , dateresend: {}
      , datelimini: {}
      , datelimend: {}
      , fincampanaapp: {}
    }
  }
};
</script>

<style>
.campana .v-select.v-select--chips.v-select--chips--small .v-select__selections {
  min-height: 32px !important;
}

.campana .v-select--is-multi:not(.v-input--is-label-active) .v-select__slot {
  padding-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/campana/Campana.vue